import React, { useEffect } from 'react'
import 'rc-tooltip/assets/bootstrap.css';
import Slider from 'rc-slider';
import { SliderProps } from 'rc-slider';
import raf from 'rc-util/lib/raf';
import Tooltip from 'rc-tooltip';

const HandleTooltip = ({ value, children, visible, tipFormatter, vertical, hideTooltip, ...otherProps }) => {
    const tooltipRef = React.useRef(null);
    const rafRef = React.useRef(null);

    const cancelKeepAlign = () => {
        if (rafRef.current) {
            raf.cancel(rafRef.current);
        }
    }

    const keepAlign = () => {
        rafRef.current = raf(() => {
            if (tooltipRef.current) {
                tooltipRef.current.forcePopupAlign();
            }
        });
    }

    useEffect(() => {
        
        if (visible) {
            keepAlign();
        }
        else {
            cancelKeepAlign();
        }
    }, [value, visible]);

    return (<Tooltip
        placement={vertical === true ? 'left' : 'top'}
        overlay={value}
        overlayInnerStyle={{ minHeight: 'auto', minWidth: 'auto' }}
        ref={tooltipRef}
        visible={visible}
        hideTooltip={hideTooltip}
        {...otherProps}
    >
        {children}
    </Tooltip>);
}

export const handleRender = (node, props) => {
    return (
        <HandleTooltip value={props.value} visible={props.dragging} orientation={props.orientation} >
            {node}
        </HandleTooltip>
    )
}

const TooltipSlider = ({
    tipFormatter,
    tipProps,
    ...props
}) => {
    const tipHandleRender = (node, handleProps) => {
        return (
            <HandleTooltip
                value={handleProps.value}
                visible={handleProps.dragging && !(props.hideTooltip === true)}
                tipFormatter={tipFormatter}
                {...tipProps}
                vertical={props.vertical}>
                {node}
            </HandleTooltip>
        )
    };

    return <Slider {...props} handleRender={tipHandleRender} />

}

export default TooltipSlider;
